import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { LegalApiRepository } from '../repositories/legal-api.repository';
import { LegalCacheRepository } from '../repositories/legal-cache.repository';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class LegalProvider {
    constructor(private legalApiRepository: LegalApiRepository, private legalCacheRepository: LegalCacheRepository) {}

    text(): Observable<Transaction<string>> {
        return concat(
            this.legalCacheRepository.load(),
            this.legalApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.legalCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
